let listeners = [];
let idCounter = 0;

const emit = (type, message) => {
  const id = ++idCounter;
  const item = { id, type, message };
  listeners.forEach((cb) => cb(item));
  return id;
};

export const toast = {
  success: (message) => emit('success', message),
  error: (message) => emit('error', message),
  info: (message) => emit('info', message),
};

export const subscribeToast = (cb) => {
  listeners.push(cb);
  return () => {
    listeners = listeners.filter((l) => l !== cb);
  };
};
